export const ROLE_TOGGLE_BASE_CLASS =
    'inline-flex h-8 w-24 items-center justify-center gap-1 px-2 text-xs font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50';
export const ROLE_TOGGLE_ACTIVE_CLASS = 'bg-primary-500 font-semibold text-white';
export const ROLE_TOGGLE_INACTIVE_CLASS =
    'bg-white text-neutral-700 hover:bg-neutral-50 active:bg-neutral-100';
export const ROLE_TOGGLE_GROUP_CLASS =
    'inline-flex shrink-0 divide-x divide-neutral-300 overflow-hidden rounded-md border border-neutral-300 bg-white';
